import { createContext, ReactNode, useContext, useMemo } from 'react';
import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { AuthenticationApi, Configuration, WebMedicalCentersApi } from 'generated/axios';
import { getCookie } from 'react-use-cookie';
import { TOKENS } from './useAuth';

const axiosInstance: AxiosInstance = axios.create();

export interface BaseAuthApiParams {
  configuration?: Configuration;
  basePath: undefined;
  axiosInstance: AxiosInstance;
}

interface AuthApiContextType {
  conf: BaseAuthApiParams;
  authApi: AuthenticationApi;
  authMedicalCenter: WebMedicalCentersApi;
}

const AuthApiContext = createContext<AuthApiContextType>({} as AuthApiContextType);

export function AuthApiContextProvider({ children }: { children: ReactNode }): JSX.Element {
  //INTERCEPTOR RESPONSE OK
  const handleResponse = (res: AxiosResponse) => {
    return res;
  };

  //INTERCEPTOR RESPONSE KO
  const handleError = async (error: any) => {
    // Access Token was expired
    if (error.response) {
      return error.response;
    }
  };

  //INTERCEPTOR REQUEST OK
  const handleRequest = (conf: InternalAxiosRequestConfig) => {
    let temp = conf.headers;
    const rawTokens = getCookie(TOKENS);
    if (rawTokens) {
      const token = JSON.parse(rawTokens).access_token;
      if (token && temp) {
        temp['Authorization'] = 'Bearer ' + token;
      }
      conf.headers = temp;
    }

    // conf.url = conf.url?.replaceAll('pageable.', '');
    return conf;
  };

  axiosInstance.interceptors.response.use(handleResponse, handleError);

  axiosInstance.interceptors.request.use(handleRequest);

  const cachedValue: AuthApiContextType = useMemo(
    () => ({
      conf: {
        configuration: new Configuration(),
        basePath: undefined,
        axiosInstance: axiosInstance,
      },
      authApi: new AuthenticationApi(new Configuration(), undefined, axiosInstance),
      authMedicalCenter: new WebMedicalCentersApi(new Configuration(), undefined, axiosInstance),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <AuthApiContext.Provider value={cachedValue}>{children}</AuthApiContext.Provider>;
}

//hook per utilizzo webSocket
export const useAuthApi = () => useContext(AuthApiContext);
